const URL_GET_KODE_OTP_AUTH = '/account/otp-auth';
// const GET_TOKEN =
//    'eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjIzMDg3OTU2NDcsImlzcyI6InN0YWdpbmctYXBpLndpcy1wYXkuY29tIiwiYXVkIjpbIllvdW5nIiwiT2xkIl0sIm91dGxldF9pZCI6NDUyfQ.d8dN80IEg0UIiaMqNiIBZAQ9m9TCnmYlr5b6dsZBykI';
// const GET_PIN = '010101';
// const GET_SIGNATURE =
//    'b9c48be8-a740-4747-a9e1-7a23e747bc23-2023-03-01 11:12:19.000000';
// Production
// const GET_TOKEN =
//    'eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NDY1MjQyNjksImlzcyI6InN0YWdpbmctYXBpLndpcy13aXMuY29tIiwiYXVkIjpbIllvdW5nIiwiT2xkIl0sIm91dGxldF9pZCI6NH0.k4NwbmJ5DqDTrvVBZLPQX9OswIDAuG6w0-vhtOQYnK8';
// const GET_SIGNATURE =
//    '2bb87395-9d34-4407-8f71-a69e3009bff0-2025-05-07 17:44:45.660033';
const GET_PIN = '101010';
const URL_GET_PRODUCTS = '/home?section=team_buying';
const URL_GET_PROFILE = '/account/profile';
const URL_GET_PRODUCTS_CATEGORIES = '/product-categories?in_webview=true';
const URL_GET_PRODUCTS_BRANDS =
   '/product-categories/%(id)s/product-brands?%(params)s';
const URL_GET_PRODUCTS_SUBCATEGORIES =
   '/product-brands/%(id)s/product-subcategories?%(params)s';
const URL_GET_SUBCATEGORIES_PRODUCTS =
   '/products?product_subcategory_id=%(id)s%(params)s';
const URL_GET_TOKEN_PRODUCT = '/transaction/%(supplier)s/%(product)s/order';
const URL_GET_PAYMENT_CODE = '/transaction/%(supplier)s/%(product)s/confirm';
const URL_GET_TRANSACTION_DETAIL = '/transactions/%(id)s';
const URL_GET_OUTLET_POINT = '/outlet-points?%(params)s';
const URL_GET_OUTLET_WALLETS = '/outlet-wallets?%(params)s';
const URL_GET_PRODUCT = '/products?%(params)s';
const URL_GET_COIN_CONVERSION = '/transaction/wiswis/coin-conversion/confirm';

export {
   URL_GET_KODE_OTP_AUTH,
   URL_GET_PRODUCTS,
   URL_GET_PRODUCTS_CATEGORIES,
   URL_GET_PRODUCTS_BRANDS,
   URL_GET_PRODUCTS_SUBCATEGORIES,
   URL_GET_SUBCATEGORIES_PRODUCTS,
   // GET_TOKEN,
   // GET_SIGNATURE,
   URL_GET_PRODUCT,
   URL_GET_OUTLET_WALLETS,
   URL_GET_COIN_CONVERSION,
   GET_PIN,
   URL_GET_TOKEN_PRODUCT,
   URL_GET_PAYMENT_CODE,
   URL_GET_TRANSACTION_DETAIL,
   URL_GET_PROFILE,
   URL_GET_OUTLET_POINT,
};
